// extracted by mini-css-extract-plugin
export var container = "IndividualSetStatistics-module--container--5cef6";
export var statistics = "IndividualSetStatistics-module--statistics--163c0";